// src/pages/VerifyEmail.js
import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Loader2, CheckCircle, XCircle } from 'lucide-react'; // Iconos de Lucide

function VerifyEmail() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Token de verificación no encontrado o inválido.');
      return;
    }

    // Usar ruta relativa para aprovechar el proxy (si está configurado)
    fetch(`/api/verify-email?token=${token}`)
      .then(async (res) => { // Hacerla async para leer el body en errores también
        const data = await res.json(); // Intentar leer JSON siempre
        if (!res.ok) {
           // Lanzar error para que lo capture el catch, usando el mensaje del backend si existe
           throw new Error(data.error || `Error ${res.status}: ${res.statusText}`);
        }
        return data; // Devolver data si res.ok
      })
      .then(data => {
        setStatus('success');
        setMessage(data.message || 'Correo verificado correctamente.'); // Usar mensaje o default
      })
      .catch((error) => {
        console.error("Verification Error:", error);
        setStatus('error');
        // Usar el mensaje del error lanzado o un mensaje genérico
        setMessage(error.message || 'Ocurrió un problema al verificar el correo.');
      });
  }, [params]); // params es la dependencia correcta

  const renderContent = () => {
    switch (status) {
      case 'loading':
        return (
          <>
            <Loader2 className="w-12 h-12 text-purple-400 animate-spin mb-4" />
            <h2 className="text-xl font-semibold text-white mb-2">
              Verificando tu cuenta...
            </h2>
            <p className="text-gray-400">Un momento por favor.</p>
          </>
        );
      case 'success':
        return (
          <>
            <CheckCircle className="w-16 h-16 text-green-500 mb-4" />
            <h2 className="text-2xl font-bold text-white mb-2">
              ¡Verificación Exitosa!
            </h2>
            <p className="text-gray-300 mb-6">{message}</p>
            <Link
              to="/login" // Siempre dirigir a login después de verificar exitosamente
              className="inline-block px-8 py-3 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg text-white font-bold text-base shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              Ir a Iniciar Sesión
            </Link>
          </>
        );
      case 'error':
        return (
          <>
            <XCircle className="w-16 h-16 text-red-500 mb-4" />
            <h2 className="text-2xl font-bold text-white mb-2">
              Error en la Verificación
            </h2>
            <p className="text-gray-300 mb-6">{message}</p>
            <Link
              to="/" // Dirigir a la landing si hay error
              className="inline-block px-8 py-3 bg-gray-700 hover:bg-gray-600 rounded-lg text-white font-medium text-base transition-colors duration-300"
            >
              Volver al Inicio
            </Link>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-gray-200 flex items-center justify-center p-4">
      {/* Quitamos el Header genérico, esta página es bastante independiente */}
      <div className="bg-gray-900/80 backdrop-blur-sm border border-gray-700/50 rounded-xl shadow-2xl max-w-md w-full p-8 sm:p-10 text-center">
        {renderContent()}
      </div>
    </div>
  );
}

export default VerifyEmail;